import { getProductsList } from './tmr-products.js';
import { getCategory } from './tmr-products.js';
import {fetchExtraProductInfo} from "../../data-layer/src/fetch-extra-product-info";

export function tmrCategoryView(items) {
    return fetchExtraProductInfo(items.map(item => item.id))
        .then((/** Map<string, ProductExtraInfo> */items) => {
            return items.map((item) => ({
                ...item,
            }));
        })
        .then((products) => ({
                type: 'itemView',
                productid: getProductsList(products),
                pagetype: getCategory(products),
                list: '1'
        }))
}